import React from 'react';
import { useTranslation } from 'react-i18next';
import { errorScreen as events } from '../../../../lib/analytics/events';
import styles from '../../styles/SubscriptionContainer.module.scss';
import SubscriptionAppBar from '../SubscriptionAppBar';
import Button from '../../../../components/Button';
import { DIGITAL_SUPPORT_LINE_NAME, PHONE_SUPPORT_NUMBER } from '../../../../lib/util/phoneSupport';

export default function ErrorScreen() {
  const { t } = useTranslation();
  events.pageLoad();

  const phoneIconUrl = '/phone_icon.png';

  return (
    <>
      <div className={styles.fullWidthWrapper}>
        <SubscriptionAppBar
          backButtonAnalyticsEvent={() => events.back()}
          closeButtonAnalyticsEvent={() => events.close()}
        />
        <div className={styles.subscriptionContainer}>
          <h1>{t('error_loading_page')}</h1>

          <div className={styles.content}>
            <p>
              {t(
                'we_couldnt_find_a_subscription_for_your_collar_so_we_cant_process_your_request_please_try_again_or_contact_our_customer_experience_team_for_help',
              )}
            </p>

            <div className={styles.inlineButtons}>
              <Button
                className={styles.button}
                secondary={true}
                onClick={() => {
                  events.callCx();
                  const phoneSupportDeeplinkUrl = `fi://phone_support?digitalSupportLineName=${DIGITAL_SUPPORT_LINE_NAME}&phoneSupportNumber=${PHONE_SUPPORT_NUMBER}`;
                  window.open(phoneSupportDeeplinkUrl);
                }}
              >
                <img src={phoneIconUrl} alt={t('call')} className={styles.buttonIcon} />
                {t('call')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
